export default __webpack_public_path__ + "aefe73860645caeed42f00e06a973ddc.png";